import styled from 'styled-components';

export const StAccessibility = styled.div`
    a {
        color: #c92727;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;